const browse = (state = [], action) => {
  const { payload, type } = action;

  switch (type) {
    case 'INITIAL_DATA':
      return payload.subscriptions || [];

    case 'SET_SUBSCRIPTIONS':
      return payload;

    case 'SUBSCRIBE':
      return [...payload.items, ...state];

    case 'UNSUBSCRIBE':
      return state.filter((x) => x._id !== payload.subscription._id);

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default browse;
